// extracted by mini-css-extract-plugin
export default {"wrapper":"TextPage_wrapper__B93gz","title-wrapper":"TextPage_title-wrapper__tBC8y","content":"TextPage_content__gHhza"};